Ext.define('SA.data.AttributeFormats', {
    singleton: true,

    getFormatsForAttributeType(type) {
        if (['count', 'mean', 'median'].includes(type)) {
            return ['integer', 'currency', '2 decimal places'];
        }

        if (type === 'percent') {
            return ['percent'];
        }

        return [];
    },

    getTextForFormat(format) {
        return {
            'currency': 'Currency',
            'integer': 'Integer',
            'percent': 'Percent',
            '2 decimal places': '2 Decimal Places'
        }[format];
    }
});
